import { create } from "zustand";
import Cookies from "js-cookie";
import {
  clearAuthSessionDate,
  isAuthSessionCurrent,
  markAuthSessionStarted,
} from "../utils/authSession";

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user")) || null;
  } catch {
    return null;
  }
};

const getInitialAuthState = () => {
  const user = getStoredUser();
  const token = Cookies.get("token") || null;

  if (token && user && isAuthSessionCurrent()) {
    return { user, token };
  }

  Cookies.remove("token");
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  clearAuthSessionDate();
  return { user: null, token: null };
};

const initialAuthState = getInitialAuthState();

export const useAuth = create((set) => ({
  user: initialAuthState.user,
  token: initialAuthState.token,

  login: (user, token) => {
    Cookies.set("token", token, { expires: 7, sameSite: "lax" });
    localStorage.setItem("user", JSON.stringify(user));
    markAuthSessionStarted();
    set({ user, token });
  },

  logout: () => {
    Cookies.remove("token");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    clearAuthSessionDate();
    set({ user: null, token: null });
  },
}));
